module.exports = __webpack_public_path__ + "static/media/hack_1_bg.472dc1e9.jpg";